module.exports = __webpack_public_path__ + "img/ico-expand-cards.785e92af.svg";